export const SEO_BUSINESS = 'seo business' as const;
export const SEO_PREMIUM = 'seo premium' as const;
export const SEO_ENTERPRISE = 'seo enterprise' as const;
export const SEO_ENTERPRISE_PLUS = 'seo enterprise +' as const;
